import React from "react";
// import "./index.scss";
import { Box } from "@mui/material";
import "../../pages/style.scss";

const Glass = ({ children, className = "" }) => {
    if (!React.isValidElement(children)) return null;

    return (
        <>
            <Box
                className={`fx-wrap ${className || ""}`}
                sx={{ display: "inline-flex" }}   // ensures width control works
            >
                {React.cloneElement(children, {
                    className: `fx-core ${children.props.className || ""}`,
                    style: {
                        ...children.props.style,
                        width: children.props.style?.width || "100%",
                        borderRadius: "inherit" // allow dynamic radius from parent
                    }
                })}
                <div className="fx-shadow" />
            </Box>

        </>
    );
};
export default Glass;
